import { Module } from "vuex";
import { $api } from "@/services/api";
import {
  RefiApplicationDetailsViewModel,
  RefiLoanViewModel,
  RefiLoanRequest,
  RefiLoanModalViewModel,
} from "@/models/refi";
import { UpdateRefiLoansRequest } from "@/models/vuex";
import { ProductIds } from "@/config/constants";

const applicationInfoModule: Module<any, any> = {
  namespaced: true,
  state: {
    applicationInfo: {} as RefiApplicationDetailsViewModel,
    loanDetailsModalActive: false as boolean,
    interestRateAndLoanTermModalActive: false as boolean,
    borrowAmountModalActive: false as boolean,
    loanOptionsModalActive: false as boolean,
    studentInformationModalActive: false as boolean,
    schoolConfirmationModalActive: false as boolean,
    confirmYourRefinanceDetailsModalActive: false as boolean,
    confirmYourLoanDetailsModalActive: false as boolean,
    pelSchoolConfirmationModalActive: false as boolean,
    pelLoanConfigurationModalActive: false as boolean,
    originalRefiLoans: [] as RefiLoanViewModel[],
    refiLoans: [] as RefiLoanViewModel[],
    loanModal: {} as RefiLoanModalViewModel,
    currentlyActiveModal: "" as string,
    currentlyActiveModals: [] as string[],
    updateRefiLoansError: false as boolean,
    getRefiLoansError: false as boolean,
    updatingRefiLoans: false as boolean,
    savingChanges: false as boolean,
    calculatedEstimatedTotalToRefinance: 0 as number,
    gettingLoanDetails: false as boolean,
  },
  mutations: {
    SET_GETTING_LOAN_DETAILS(state: any, flag: boolean) {
      state.gettingLoanDetails = flag;
    },
    SET_CAN_EDIT_FLAG(state: any, flag: boolean) {
      state.applicationInfo.canEdit = flag;
    },
    SET_REFI_LOANS(state: any, refiLoans: Array<RefiLoanViewModel>) {
      state.refiLoans = refiLoans;
    },
    SET_REFI_LOAN_MODAL(state: any, loanModal: RefiLoanModalViewModel) {
      state.loanModal = loanModal;
    },
    SET_UPDATING_REFI_LOANS(state: any, flag: boolean) {
      state.updatingRefiLoans = flag;
    },
    SET_SAVING_CHANGES(state: any, flag: boolean) {
      state.savingChanges = flag;
    },
    SET_UPDATE_REFI_LOANS_ERROR(state: any, flag: boolean) {
      state.updateRefiLoansError = flag;
    },
    SET_GET_REFI_LOANS_ERROR(state: any, flag: boolean) {
      state.getRefiLoansError = flag;
    },
    SET_CURRENTLY_ACTIVE_MODAL(state: any, modal: string) {
      state.currentlyActiveModal = modal;
    },
    DISCARD_CHANGES(state: any) {
      state.applicationInfo.loans = state.originalRefiLoans;
      state.loanModal.loans = state.originalRefiLoans;
    },
    SET_APPLICATION_INFO(state: any, info: RefiApplicationDetailsViewModel) {
      state.applicationInfo = info;
    },
    SET_APPLICATION_INFO_LOANS(state: any, refiLoans: Array<RefiLoanViewModel>) {
      state.applicationInfo.loans = refiLoans;
    },
    SET_ORIGINAL_REFI_LOANS(state: any, loans: any) {
      state.originalRefiLoans = loans;
    },
    TOGGLE_MODAL(state: any, modal: any) {
      // state.currentlyActiveModals.push(modal);
      const index = state.currentlyActiveModals.findIndex((m: string) => m === modal);

      if (index === -1) {
        state.currentlyActiveModals.push(modal);
      }
    },
    UNTOGGLE_MODAL(state: any, modal: any) {
      const index = state.currentlyActiveModals.findIndex((m: string) => m === modal);
      console.log("index", index);
      if (index !== -1) {
        state.currentlyActiveModals.splice(index, 1);
      }
    },
    OPEN_LOAN_DETAILS_MODAL(state: any) {
      state.loanDetailsModalActive = true;
    },
    CLOSE_LOAN_DETAILS_MODAL(state: any) {
      state.loanDetailsModalActive = false;
    },
    OPEN_INTEREST_RATE_AND_LOAN_TERM_MODAL(state: any) {
      state.interestRateAndLoanTermModalActive = true;
    },
    CLOSE_INTEREST_RATE_AND_LOAN_TERM_MODAL(state: any) {
      state.interestRateAndLoanTermModalActive = false;
    },
    OPEN_CONFIRM_YOUR_REFINANCE_DETAILS_MODAL(state: any) {
      state.confirmYourRefinanceDetailsModalActive = true;
    },
    CLOSE_CONFIRM_YOUR_REFINANCE_DETAILS_MODAL(state: any) {
      state.confirmYourRefinanceDetailsModalActive = false;
    },
    OPEN_CONFIRM_YOUR_LOAN_DETAILS_MODAL(state: any) {
      state.confirmYourLoanDetailsModalActive = true;
    },
    CLOSE_CONFIRM_YOUR_LOAN_DETAILS_MODAL(state: any) {
      state.confirmYourLoanDetailsModalActive = false;
    },
    OPEN_PEL_SCHOOL_CONFIRMATION_MODAL(state: any) {
      state.pelSchoolConfirmationModalActive = true;
    },
    CLOSE_PEL_SCHOOL_CONFIRMATION_MODAL(state: any) {
      state.pelSchoolConfirmationModalActive = false;
    },
    OPEN_PEL_LOAN_CONFIGURATION_MODAL(state: any) {
      state.pelLoanConfigurationModalActive = true;
    },
    OPEN_BORROW_AMOUNT_MODAL(state: any) {
      state.borrowAmountModalActive = true;
    },
    CLOSE_BORROW_AMOUNT_MODAL(state: any) {
      state.borrowAmountModalActive = false;
    },
    OPEN_LOAN_OPTIONS_MODAL(state: any) {
      state.loanOptionsModalActive = true;
    },
    OPEN_STUDENT_INFORMATION_MODAL(state: any) {
      state.studentInformationModalActive = true;
    },
    CLOSE_LOAN_OPTIONS_MODAL(state: any) {
      state.loanOptionsModalActive = false;
    },
    CLOSE_PEL_LOAN_CONFIGURATION_MODAL(state: any) {
      state.pelLoanConfigurationModalActive = false;
    },
    OPEN_SCHOOL_CONFIRMATION_MODAL(state: any) {
      state.schoolConfirmationModalActive = true;
    },
    CLOSE_SCHOOL_CONFIRMATION_MODAL(state: any) {
      state.schoolConfirmationModalActive = false;
    },
    CLOSE_STUDENT_INFORMATION_MODAL(state: any) {
      state.studentInformationModalActive = false;
    },
    CLOSE_ALL_MODALS(state: any) {
      state.loanDetailsModalActive = false;
      state.interestRateAndLoanTermModalActive = false;
      state.confirmYourRefinanceDetailsModalActive = false;
      state.confirmYourLoanDetailsModalActive = false;
      state.pelSchoolConfirmationModalActive = false;
      state.pelLoanConfigurationModalActive = false;
      state.borrowAmountModalActive = false;
      state.schoolConfirmationModalActive = false;
      state.loanOptionsModalActive = false;
      state.loanConfigurationModalActive = false;
      state.studentInformationModalActive = false;

      state.currentlyActiveModal = "";
    },
    UPDATE_REFI_LOAN(state: any, updatedRefiLoan: RefiLoanViewModel) {
      const index = state.loanModal?.loans?.findIndex(
        (loan: any) => loan.id === updatedRefiLoan.id,
      );

      if (index > -1) {
        state.loanModal.loans[index] = updatedRefiLoan;
      }
    },
    SET_CALCULATED_ESTIMATED_TOTAL_TO_REFINANCE(state: any, amount: number) {
      state.calculatedEstimatedTotalToRefinance = amount;
    },
    SET_STUDENT_INFORMATION_MODAL(state: any, data: any) {
      state.studentInformationModal = data;
    },
  },
  actions: {
    async getStudentInfo({ commit }, referenceId: string) {
      const response = await $api.applications.getStudentInformationModal(referenceId);

      if (response.success) {
        commit("SET_STUDENT_INFORMATION_MODAL", response.results);
        return true;
      } else {
        return false;
      }
    },
    async getRefiDetails({ commit, state }, applicationId: number) {
      const response = await $api.refi.getRefiDetails(applicationId);

      if (response && !response.error) {
        commit("SET_APPLICATION_INFO", response);
        commit("SET_CALCULATED_ESTIMATED_TOTAL_TO_REFINANCE", response.estimatedTotal);
        state.originalRefiLoans = response?.loans;
      }
    },
    discardChanges({ commit, state }) {
      commit("DISCARD_CHANGES");
    },
    openBorrowAmountModal({ commit }) {
      commit("OPEN_BORROW_AMOUNT_MODAL");
    },
    closeBorrowAmountModal({ commit }) {
      commit("CLOSE_BORROW_AMOUNT_MODAL");
    },
    setCanEdit({ commit }, flag: boolean) {
      commit("SET_CAN_EDIT_FLAG", flag);
    },
    gettingLoanDetails({ commit }, flag: boolean) {
      commit("SET_GETTING_LOAN_DETAILS", flag);
    },
    openModal({ commit, rootState }, payload) {
      switch (payload) {
        case "SchoolConfirmationModal":
        case "LocSchoolConfirmationModal":
          if (rootState.appData.application?.productTypeId === ProductIds.LOC) {
            commit("OPEN_SCHOOL_CONFIRMATION_MODAL");
            commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          }
          if (rootState.appData.application?.productTypeId === ProductIds.PEL) {
            commit("OPEN_PEL_SCHOOL_CONFIRMATION_MODAL");
            commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          }
          break;
        case "BorrowAmountModal":
          commit("OPEN_BORROW_AMOUNT_MODAL");
          commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          break;
        case "LoanOptionsModal":
          commit("OPEN_LOAN_OPTIONS_MODAL");
          commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          break;
        case "LoanDetails":
          commit("OPEN_LOAN_DETAILS_MODAL");
          commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          break;
        case "InterestRateAndLoanTerm":
          commit("OPEN_INTEREST_RATE_AND_LOAN_TERM_MODAL");
          commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          break;
        case "ConfirmYourRefinanceDetails":
          commit("OPEN_CONFIRM_YOUR_REFINANCE_DETAILS_MODAL");
          commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          commit("TOGGLE_MODAL", payload);
          break;
        case "ConfirmYourLoanDetails":
          commit("OPEN_CONFIRM_YOUR_LOAN_DETAILS_MODAL");
          commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          commit("TOGGLE_MODAL", payload);
          break;
        case "PelSchoolConfirmationModal":
          commit("OPEN_PEL_SCHOOL_CONFIRMATION_MODAL");
          commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          break;
        case "PelLoanConfigurationModal":
        case "LocLoanConfigurationModal":
          commit("OPEN_PEL_LOAN_CONFIGURATION_MODAL");
          commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          break;
        case "StudentInformationModal":
          commit("OPEN_STUDENT_INFORMATION_MODAL");
          commit("SET_CURRENTLY_ACTIVE_MODAL", payload);
          break;
        default:
          commit("SET_CURRENTLY_ACTIVE_MODAL", "");
          return;
      }
    },
    closeModal({ commit, state, dispatch }, payload) {
      commit("CLOSE_ALL_MODALS");
      commit("SET_CURRENTLY_ACTIVE_MODAL", "");

      switch (payload) {
        case "LoanDetails":
          commit("CLOSE_LOAN_DETAILS_MODAL");
          break;
        case "InterestRateAndLoanTerm":
          commit("CLOSE_INTEREST_RATE_AND_LOAN_TERM_MODAL");
          break;
        case "ConfirmYourRefinanceDetails":
          commit("CLOSE_CONFIRM_YOUR_REFINANCE_DETAILS_MODAL");
          commit("UNTOGGLE_MODAL", payload);
          break;
        case "ConfirmYourLoanDetails":
          commit("CLOSE_CONFIRM_YOUR_LOAN_DETAILS_MODAL");
          commit("UNTOGGLE_MODAL", payload);
          break;
        case "PelSchoolConfirmationModal":
          commit("CLOSE_PEL_SCHOOL_CONFIRMATION_MODAL");
          break;
        case "PelLoanConfigurationModal":
        case "LocLoanConfigurationModal":
          commit("CLOSE_PEL_LOAN_CONFIGURATION_MODAL");
          break;
        case "SchoolConfirmationModal":
        case "LocSchoolConfirmationModal":
          commit("CLOSE_SCHOOL_CONFIRMATION_MODAL");
          break;
        case "BorrowAmountModal":
          commit("CLOSE_BORROW_AMOUNT_MODAL");
          break;
        case "LoanOptionsModal":
          commit("CLOSE_LOAN_OPTIONS_MODAL");
          break;
        case "StudentInformationModal":
          commit("CLOSE_STUDENT_INFORMATION_MODAL");
          break;
        default:
          return;
      }

      if (state.currentlyActiveModals?.includes("ConfirmYourRefinanceDetails")) {
        dispatch("openModal", "ConfirmYourRefinanceDetails");
      }

      if (state.currentlyActiveModals?.includes("ConfirmYourLoanDetails")) {
        dispatch("openModal", "ConfirmYourLoanDetails");
      }
    },
    updateRefiLoan({ commit }, updatedRefiLoan: RefiLoanViewModel) {
      commit("UPDATE_REFI_LOAN", updatedRefiLoan);
    },
    setCalculatedEstimatedTotalToRefinance({ commit, state }, amount: number) {
      commit("SET_CALCULATED_ESTIMATED_TOTAL_TO_REFINANCE", amount);
    },
    setSavingChanges({ commit }, payload: boolean) {
      commit("SET_SAVING_CHANGES", payload);
    },
    async getRefiLoanModalData({ state, commit }, payload: any) {
      commit("SET_GET_REFI_LOANS_ERROR", false);

      const refiLoanModalViewModel = await $api.refi.getRefiLoans(payload);

      if (refiLoanModalViewModel) {
        commit("SET_REFI_LOAN_MODAL", refiLoanModalViewModel);
      } else {
        commit("SET_GET_REFI_LOANS_ERROR", true);
      }
    },
    async updateRefiLoans({ commit, dispatch, getters }, payload: UpdateRefiLoansRequest) {
      commit("SET_UPDATING_REFI_LOANS", true);
      commit("SET_UPDATE_REFI_LOANS_ERROR", false);

      const updatedLoans = await $api.refi.updateRefiLoans(
        payload.applicationId,
        payload.applicantId,
        getters.RefiLoansToUpdate,
      );

      if (updatedLoans && updatedLoans?.loans?.length > 0) {
        commit("SET_REFI_LOAN_MODAL", updatedLoans);

        // state.originalRefiLoans = updatedLoans.loans;
        commit("SET_ORIGINAL_REFI_LOANS", updatedLoans.loans);
        commit("SET_APPLICATION_INFO_LOANS", updatedLoans.loans);
        dispatch("closeModal", "LoanDetails");
        commit("SET_UPDATING_REFI_LOANS", false);
      } else {
        commit("SET_UPDATE_REFI_LOANS_ERROR", true);
        commit("SET_UPDATING_REFI_LOANS", false);
      }

      await dispatch("getRefiDetails", payload.applicationId);
    },
  },
  getters: {
    RefiLoansToUpdate: (state: any): Array<RefiLoanRequest> => {
      return state?.loanModal?.loans?.map((r: RefiLoanViewModel) => {
        return {
          id: r.id,
          include: r.include,
        };
      });
    },
    ModalComponent: (state: any): string => {
      return state.currentlyActiveModal;
    },
    RefiLoans: (state: any): Array<RefiLoanViewModel> => {
      return state?.applicationInfo?.loans || [];
    },
    FilteredOriginalRefiLoans: (state: any): Array<RefiLoanViewModel> => {
      return (
        (state?.originalRefiLoans &&
          state?.originalRefiLoans?.filter((l: RefiLoanViewModel) => l.include)) ||
        []
      );
    },
    FilteredRefiLoans: (state: any): Array<RefiLoanViewModel> => {
      return (
        (state?.applicationInfo?.loans &&
          state?.applicationInfo?.loans?.filter((l: RefiLoanViewModel) => l.include)) ||
        []
      );
    },
    ConfirmYourRefinanceDetailsModalOpen: (state: any): boolean => {
      const index = state.currentlyActiveModals.findIndex(
        (m: string) => m === "ConfirmYourRefinanceDetails",
      );

      return index !== -1;
    },
    ConfirmYourLoanDetailsModalOpen: (state: any): boolean => {
      const index = state.currentlyActiveModals.findIndex(
        (m: string) => m === "ConfirmYourLoanDetails",
      );

      return index !== -1;
    },
  },
};

export default applicationInfoModule;
